import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const url = "https://redemeaiyg.execute-api.us-east-1.amazonaws.com/to-do";

const AddToDoQuery = `
    mutation AddNewTodo($title: String!, $description: String!) {
        addToDo(title: $title, description: $description) {
            status
            errors
            data {
                PK
                SK
                title
                completed
                description
                
            }
        }
    }
`;

const GetToDoListQuery = `
    query {
        getToDoList {
            status
            errors
            data {
                PK
                SK
                title
                description
                completed
                
            }
        }
    }
`;

const UpdateToDoQuery = `
    mutation UpdateToDo($input: updateToDoInput!) {
        updateToDo(input: $input){
            status
            errors
            data {
                PK
                SK
                title
                description
                completed
            }
        }
    }
`;

const DeleteToDoQuery = `
    mutation DeleteToDo($sk: String!) {
        deleteToDo(SK: $sk){
            status
            errors
            data {
                PK
                SK
                title
                description
                completed
            }
        }
    }
`;

export interface ToDoType {
    PK: string;
    SK: string;
    title: string;
    description?: string;
    completed: boolean;
    type: string;
}

interface InitialState {
    status: "idle" | "loading" | "succeeded" | "failed";
    errors: [string] | null;
    todoList: [ToDoType] | null;
}

const initialState: InitialState = {
    status: "idle",
    errors: null,
    todoList: null,
}

export const getToDoList = createAsyncThunk("todo/getToDoList", async () => {
    const token = localStorage.getItem("token");
    const response = await axios.post(url, {
        query: GetToDoListQuery,
    }, {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
    });
    // console.log(localStorage.getItem("token"));
    return response.data.data.getToDoList;
});

export const updateToDo = createAsyncThunk("todo/updateToDo", async (toDo: { SK: string, title: string, description?: string, completed: boolean, type?: "toggle" }) => {
    let { completed, SK, title, description } = toDo;
    console.log(toDo)
    if (toDo?.type === "toggle") {
        completed = !completed;
    }
    const token = localStorage.getItem("token");
    const response = await axios.post(url, {
        query: UpdateToDoQuery,
        variables: {
            input: {
                SK,
                title,
                description,
                completed: completed,
            },
        },
    }, {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
    });
    return response.data.data.updateToDo;
})

export const addToDo = createAsyncThunk("todo/addToDo", async (toDo: { title: string, description?: string }) => {
    const { title, description } = toDo;
    const token = localStorage.getItem("token");
    const response = await axios.post(url, {
        query: AddToDoQuery,
        variables: {
            title,
            description,
        },
    }, {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
    });
    return response.data.data.addToDo;
})

export const deleteToDo = createAsyncThunk("todo/deleteToDo", async (SK: string) => {
    const token = localStorage.getItem("token");
    const response = await axios.post(url, {
        query: DeleteToDoQuery,
        variables: {
            sk: SK,
        },
    }, {
        headers: {
            "Content-Type": "application/json",
            "Authorization": `Bearer ${token}`,
        },
    });
    return response.data.data.deleteToDo;
})

const todoSlice = createSlice({
    name: "todo",
    initialState,
    reducers: {
        clear: (state: InitialState) => {
            state.status = "succeeded"
            state.errors = null;
            state.todoList = null
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getToDoList.pending, (state, action) => {
            state.status = "loading";
        }).addCase(getToDoList.fulfilled, (state, action) => {
            const { status } = action.payload;
            if (status > 199 && status < 300) {
                state.status = "succeeded";
                state.todoList = action.payload.data;
            } else {
                state.errors = action.payload.errors;
                state.status = "failed";
            }
        }).addCase(getToDoList.rejected, (state, action) => {
            state.status = "failed";
            state.errors?.push(action.error.message!);
        }).addCase(updateToDo.fulfilled, (state, action) => {
            const { status } = action.payload;
            if (status > 199 && status < 300) {
                state.status = "succeeded";
                let existingToDo = state.todoList?.find((toDo) => toDo.SK === action.payload.data.SK);
                if (existingToDo) {
                    existingToDo.title = action.payload.data.title;
                    existingToDo.description = action.payload.data.description;
                    existingToDo.completed = action.payload.data.completed;
                }
            } else {
                state.errors = action.payload.errors;
                state.status = "failed";
            }
        }).addCase(addToDo.fulfilled, (state, action) => {
            const { status } = action.payload;
            if (status > 199 && status < 300) {
                state.status = "succeeded";
                state.todoList?.push(action.payload.data);
            } else {
                state.errors = action.payload.errors;
                state.status = "failed";
            }
        }).addCase(deleteToDo.fulfilled, (state, action) => {
            const { status } = action.payload;
            if (status > 199 && status < 300) {
                state.status = "succeeded";
                let newList = state.todoList?.filter((toDo) => toDo.SK !== action.payload.data.SK);
                // @ts-ignore
                state.todoList = newList;
            } else {
                state.errors = action.payload.errors;
                state.status = "failed";
            }
        });
    }
});

export const { clear } = todoSlice.actions;

export default todoSlice.reducer;

